import { render, staticRenderFns } from "./ResultHeadMiddlePage.vue?vue&type=template&id=45e0858f&scoped=true&"
import script from "./ResultHeadMiddlePage.vue?vue&type=script&lang=js&"
export * from "./ResultHeadMiddlePage.vue?vue&type=script&lang=js&"
import style0 from "./ResultHeadMiddlePage.vue?vue&type=style&index=0&id=45e0858f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0858f",
  null
  
)

export default component.exports